export default __webpack_public_path__ + "static/media/Image-6.4e777d71.jpg";